import styled from "styled-components";
import { DEFAULT_IPL_TIMER_GRADIENT } from "./constants";

export const Container = styled.div<{ backgroundColor?: string }>(({ backgroundColor, theme }) => {
    return {
        background: backgroundColor || DEFAULT_IPL_TIMER_GRADIENT,
        border: `1px solid ${theme.colors[theme.colorMode].border_Secondary}`,
        borderRadius: theme.cornerRadius.large,
        padding: `0 ${theme.spacing.xSmall}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: `0 ${theme.spacing.xxSmall}`,
    };
});

export const TimerSVGContainer = styled.div(({ theme }) => {
    return {
        marginRight: theme.spacing.xxSmall,
        height: "17px", //needed to add specific height to align timer svg with the text
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };
});
